import React from "react";
import {
  IconFE,
  CardLatestDeliveries,
  ContainerDescription,
  IconContainer,
  IconContainerAction,
  IconFA5,
  Subtitle,
  Title,
} from "./styles";

interface CardRoutesProps {
  title: any;
  subtitle: string;
  icon: string;
  iconAction: string;
  first?: boolean;
  onPress: () => void;
}

export default function CardRoutes({
  title,
  subtitle,
  icon,
  iconAction,
  first,
  onPress
}: CardRoutesProps) {
  return (
    <CardLatestDeliveries first={first}>
      <IconContainer>
        <IconFA5 name={icon} size={25} />
      </IconContainer>
      <ContainerDescription>
        <Title>{title}</Title>
        <Subtitle>{subtitle}</Subtitle>
      </ContainerDescription>
      <IconContainerAction onPress={onPress}>
        <IconFE name={iconAction} size={25} />
      </IconContainerAction>
    </CardLatestDeliveries>
  );
}
